import { chartColors } from '@UILibrary/utils'

export const buildLineChartPropData = (data) => {
  return ([
    {
      backgroundColor: chartColors['salem-60'],
      borderColor: chartColors['salem-60'],
      data: data.enrolled_clients.data,
      label: data.enrolled_clients.label
    },
    {
      backgroundColor: chartColors['true-blue-70'],
      borderColor: chartColors['true-blue-70'],
      data: data.coached_clients.data,
      label: data.coached_clients.label
    },
    {
      backgroundColor: chartColors['rhythm-40'],
      borderColor: chartColors['rhythm-40'],
      data: data.workshop_attended.data,
      label: data.workshop_attended.label,
    },
    {
      backgroundColor: chartColors['golden-rod-50'],
      borderColor: chartColors['golden-rod-50'],
      data: data.app_logins.data,
      label: data.app_logins.label,
    }
  ])
}

export const buildBarChartDataProp = (data) => {
  return ({
    labels: ['Enrolled', 'Contacted', 'Meetings booked', 'Received coaching'],
    datasets: [{
      backgroundColor: chartColors['true-blue-10'],
      borderColor: chartColors['true-blue-10'],
      borderRadius: 7,
      borderWidth: 1,
      data: [data.enrolled_clients, data.contacted_clients, data.meetings_booked, data.received_coaching],
      label: 'Engagement',
    }]
  })
}

export const buildWordCloudDataProp = (feedbackData) => {
  if (!feedbackData || !feedbackData.length) {
    return [];
  }

  return feedbackData.map(feedback => ({
    text: feedback.text,
    value: feedback.count,
  }))
}

export const buildWorkshopAttendanceChartDataProp = (data) => {
  if (!data || !data.workshop_names || !data.workshop_names.length) {
    return null;
  }

  return {
    labels: data.workshop_names.map(([name]) => name),
    datasets: [{
      backgroundColor: chartColors['salem-40'],
      borderColor: chartColors['salem-60'],
      borderRadius: 7,
      borderWidth: 1,
      data: data.attendance_counts,
      dates: data.workshop_names.map(([, date]) => date),
      label: 'Workshop Attendance',
    }]
  };
}

